<template>
  <div>
    <div class="hover-steps-content">
      <div class="popover-steps-arrow">&nbsp;</div>
      <div
        class="d-flex my-2"
      >
        <div class="text-right">{{ date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['date']
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/viewStepsDates.vue